import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import BussifyPreset from './bussify.preset';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { MessageService as PrimeMessageService } from 'primeng/api';
import { provideApi } from './api';
import { environment } from '../environments/environment';
import { registerLocaleData } from '@angular/common';
import localePl from '@angular/common/locales/pl';
import { LOCALE_ID } from '@angular/core';
import { ErrorInterceptor } from './auth/interceptors/error.interceptor';
import { authHttpInterceptorFn, provideAuth0 } from '@auth0/auth0-angular';
import { localAuthHttpInterceptorFn } from './auth/interceptors/local-auth.interceptor';

registerLocaleData(localePl);

const isLocalAuth = environment.auth.mode === 'local-auth';
const authInterceptors = isLocalAuth ? [localAuthHttpInterceptorFn] : [authHttpInterceptorFn];

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'pl-PL' },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: BussifyPreset,
        options: {
          darkModeSelector: '.light',
        },
      },
    }),
    ...(isLocalAuth
      ? []
      : [
          provideAuth0({
            domain: environment.auth.domain!,
            clientId: environment.auth.clientId!,
            cacheLocation: 'localstorage',
            useRefreshTokens: true,
            skipRedirectCallback: window.location.pathname === '/callback',
            authorizationParams: {
              redirect_uri: environment.auth.redirectUri || window.location.origin,
              audience: environment.auth.audience!,
            },
            httpInterceptor: {
              allowedList: [
                {
                  uri: `${environment.apiPath}/api/*`,
                  tokenOptions: {
                    authorizationParams: {
                      audience: environment.auth.audience!,
                    },
                  },
                },
              ],
            },
          }),
        ]),
    provideHttpClient(withInterceptors(authInterceptors), withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    provideApi({
      basePath: environment.apiPath,
      withCredentials: true,
    }),
    PrimeMessageService,
  ],
};
